import MuiFab, { type FabProps } from "@mui/material/Fab";

export type { FabProps };

export function Fab({ color = "primary", ...props }: FabProps) {
  return <MuiFab color={color} {...props} />;
}
